export class GroupPath {
    private readonly _value: string;

    constructor(
        private groupId: string
    ) {
        this._value = 'smiles/groups/' + this.groupId + '/';
    }

    get value() {
        return this._value;
    }
}